/* eslint-disable @typescript-eslint/indent */

type Variant = Record<
  string,
  {
    default: string;
    hover: string;
    pressed: string;
    focus: string;
    disabled: string;
  }
>;

export const buttonVariants: Variant = {
  primary: {
    default: 'bg-solar-button-primary-default text-solar-inverted-primary',
    hover: 'hover:bg-solar-button-primary-hover text-solar-inverted-primary',
    pressed: 'active:bg-solar-button-primary-pressed text-solar-inverted-primary',
    focus: 'focus:bg-solar-button-primary-focus text-solar-inverted-primary',
    disabled:
      'bg-solar-button-secondary-disabled cursor-not-allowed text-solar-disabled pointer-events-none',
  },
  secondary: {
    default: 'bg-solar-button-secondary-default text-solar-primary border border-solar-button',
    hover: 'hover:bg-solar-button-secondary-hover text-solar-primary border border-solar-button',
    pressed:
      'active:bg-solar-button-secondary-pressed text-solar-primary border border-solar-button',
    focus: 'focus:bg-solar-button-secondary-focus text-solar-primary border border-solar-button',
    disabled:
      'bg-solar-button-secondary-disabled cursor-not-allowed text-solar-secondary border border-solar-primary pointer-events-none',
  },
  tertiary: {
    default:
      'bg-solar-button-secondary-default text-solar-primary border border-solar-border-secondary',
    hover:
      'hover:bg-solar-button-secondary-hover text-solar-primary border border-solar-border-secondary',
    pressed:
      'active:bg-solar-button-secondary-pressed text-solar-primary border border-solar-border-secondary',
    focus:
      'focus:bg-solar-button-secondary-focus text-solar-primary border border-solar-border-secondary',
    disabled:
      'bg-solar-button-secondary-disabled cursor-not-allowed text-solar-secondary border border-solar-border-primary pointer-events-none',
  },
  ultramarine: {
    default: 'bg-solar-button-ultramarine-default text-solar-inverted-primary',
    hover: 'hover:bg-solar-button-ultramarine-hover text-solar-inverted-primary',
    pressed: 'active:bg-solar-button-ultramarine-pressed text-solar-inverted-primary',
    focus: 'focus:bg-solar-button-ultramarine-focus text-solar-inverted-primary',
    disabled:
      'bg-solar-button-secondary-disabled cursor-not-allowed text-solar-disabled pointer-events-none',
  },
};
